module.exports = __webpack_public_path__ + "static/media/Story-PS-TeacherPersona.4cd9706e.png";